"use client";
import { CalendarToday as StartIcon } from "@mui/icons-material";

import { useStore, observer } from "../../../../service/mobx";
import SearchFilterChip from ".";
import SearchMenu from "../../../../component/Menu/menus/Search";
import { menuOptionsTime } from "../../../../component/Menu/menus/Search/Time";

export default observer(function FilterTime() {
  const { search } = useStore();
  const disabled =
    search.filterType === undefined ||
    search.filterType === "tasks" ||
    search.filterStars !== undefined;
  const param = "time";

  return (
    <SearchFilterChip
      param={param}
      disabled={disabled}
      StartIcon={StartIcon}
      options={menuOptionsTime}
      Menu={{
        sx: { menuList: { pt: 0 } },
        Component: () => (
          <SearchMenu
            filter="time"
            param={param}
            items={Object.entries(menuOptionsTime)}
          />
        )
      }}
    />
  );
});
